<template>
    <AppLayout>
        <ProductsLayout :products="products" :categories="categories" :sort-options="sortOptions">
            <template #content>
                <h2 class="sr-only">Products</h2>

                <div v-if="products.length" class="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 xl:grid-cols-3 xl:gap-x-8">
                    <router-link v-for="product in products" :key="product.id" :to="`/courses/${product.slug}`"
                        class="group">
                        <div class="aspect-square w-full overflow-hidden rounded-2xl bg-gray-100 shadow-sm ring-1 ring-gray-900/5">
                            <img :src="product.image" :alt="product.imageAlt"
                                class="size-full object-cover transition-transform duration-300 group-hover:scale-105" />
                        </div>
                        <h3 class="mt-4 text-base font-semibold text-gray-900 group-hover:text-primary-700">{{ product.name }}</h3>
                        <p class="mt-1 text-sm font-medium text-primary-600">View course &rarr;</p>
                    </router-link>
                </div>
                <p v-else class="py-16 text-center text-sm text-gray-500">No courses found for this category yet.</p>
            </template>
        </ProductsLayout>
    </AppLayout>
</template>

<script setup>

import AppLayout from '@/components/layouts/AppLayout.vue';
import ProductsLayout from '@/components/layouts/ProductsLayout.vue';

const props = defineProps({
    products: {
        type: Array,
        default: () => []
    }
});

import { ref, watchEffect } from 'vue'
import { onMounted } from 'vue';
import { getCategories } from '@/services/categoryService';
import { getProducts } from '@/services/productService';
import { useRouter } from 'vue-router';

const router = useRouter();
const categories = ref([]);
const products = ref([]);
const sortOptions = [
    { name: 'Most Popular', href: '#', current: true },
    { name: 'Best Rating', href: '#', current: false },
    { name: 'Newest', href: '#', current: false },
]

const query = router.currentRoute.value.query;

const fetchCategories = async () => {
    await getCategories()
        .then(data => {
            categories.value = data.data.map(category => {
                return {
                    name: category.name,
                    href: `/courses?category=${category.slug}`,
                }
            });
        })
        .catch(error => {
            // console.error('Error fetching categories:', error);
        });
}

const fetchProducts = async () => {
    await getProducts()
        .then(data => {
            products.value = data.data;
        })
        .catch(error => {
            // console.error('Error fetching products:', error);
        });
}


onMounted(() => {
    fetchCategories();
    fetchProducts();
});

watchEffect(() => {
    if (query.category) {
        products.value = products.value.filter(product => {
            return product.category && product.category.slug === query.category;
        });
    }
});
</script>
